export default {
  default: () => import("/tmp/my-website-master/layouts/default.vue").then(m => m.default || m),
  error: () => import("/tmp/my-website-master/layouts/error.vue").then(m => m.default || m)
}